import { useInView } from 'react-intersection-observer';

interface ContainerProps {
  className?: string;
  animate?: boolean;
  forceAnimate?: boolean;
  id?: string;
  children: any;
  md?: boolean;
}
const Container = (props: ContainerProps) => {
  const { className, children, animate, forceAnimate, id, md } = props;
  const { ref, inView } = useInView({ threshold: 0.4, triggerOnce: true });

  return (
    <div
      ref={ref}
      className={
        'container mx-auto px-5 !max-w-full ' +
        (animate ? ' opacity-0' : '') +
        (className ? ' ' + className : '') +
        ((animate && inView) || forceAnimate ? ' animate-fade-in' : '') +
        (md ? ' !max-w-[58rem]' : '')
      }
      id={id || ''}
    >
      {children}
    </div>
  );
};

export default Container;
